import { TrashIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type DeleteIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function DeleteIconButton({ label = 'Excluir', className = '', ...props }: DeleteIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-red-50 hover:text-red-600 ${className}`}
      {...props}
    >
      <TrashIcon className="h-5 w-5" />
    </button>
  );
}
